import { useState } from 'react';
import { Button } from '@nextui-org/react';
import { User } from 'common/src/utils/types';
import TeamTable from '../../components/specifics/teams/TeamTable';
import ModalCreateEditUser from '../../components/specifics/teams/ModalCreateEditUser';
import ModalDeleteUser from '../../components/specifics/teams/ModalDeleteUser';
import useGeneralStore from '../../store/useGeneralStore';

export default function TeamPage() {
  const { users } = useGeneralStore();
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const handleEdit = (user: User) => {
    setSelectedUser(user);
    setEditModalVisible(true);
  };

  const handleDelete = (user: User) => {
    setSelectedUser(user);
    setDeleteModalVisible(true);
  };

  const handleCreate = () => {
    setSelectedUser(null);
    setEditModalVisible(true);
  };

  return (
    <div>
      <div className='flex justify-between items-center mb-4'>
        <h2 className='text-2xl font-semibold'>Tu Equipo</h2>
        <Button
          className='bg-purple-500 text-white font-semibold'
          onPress={handleCreate}
        >
          Agregar Usuario
        </Button>
      </div>

      <TeamTable users={users} onEdit={handleEdit} onDelete={handleDelete} />
      {editModalVisible && (
        <ModalCreateEditUser
          isOpen={editModalVisible}
          onClose={() => setEditModalVisible(false)}
          user={selectedUser || undefined}
        />
      )}

      {deleteModalVisible && (
        <ModalDeleteUser
          isOpen={deleteModalVisible}
          onClose={() => setDeleteModalVisible(false)}
          user={selectedUser as User}
        />
      )}
    </div>
  );
}
